import { render, staticRenderFns } from "./ClientAttentionCard.vue?vue&type=template&id=27716795&scoped=true&"
import script from "./ClientAttentionCard.vue?vue&type=script&lang=js&"
export * from "./ClientAttentionCard.vue?vue&type=script&lang=js&"
import style0 from "./ClientAttentionCard.vue?vue&type=style&index=0&id=27716795&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27716795",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCard,VCardSubtitle,VCardTitle,VChip,VDivider,VIcon,VSpacer})
